<template>
    <div class="static-form" v-if="!showCatalogs">
        <form class="vue_contact_form">
            <!-- header -->
            <Header 
                :title="data.config_json && data.config_json.form_title ? data.config_json.form_title : data.title"
                :description="data.description"/>
            <!-- layout -->
            <div v-for="(field , index) in formFields"
                class="vue_title_container"
                :class="field.help">
                <FieldLayoutManager
                    v-if="!(disabledFields[field.slug] && readonly) || field.slug === 'phone'"
                    :fieldData="field"
                    :readonly="disabledFields[field.slug] && readonly"
                    v-model="formFilled[field.slug]"/>
            </div>

            <!-- Cloudflare Turnstile -->
            <div class="vue_title_container">
                <div :id="turnstileContainerId"></div>
            </div>

            <!-- Footer -->
            <Footer :data="data" :formFilled="formFilled" :buttonText="buttonText" :locale="locale" :turnstileToken="turnstileToken" @finished="finished"/>
        </form>
    </div>
    <div class="row" v-else-if="catalogs.length > 0">
        <div class="text-center catalog-title" v-if="textHelpers && textHelpers.catalogTitle" v-html="textHelpers.catalogTitle"></div>
        
        <div class="d-flex flex-wrap align-items-center justify-content-center">
            <div class="col-12 col-sm-6 col-md-4 col-xl-3 d-flex align-items-center flex-column justify-content-center mb-3" v-for="(catalog, index) in catalogs" :key="index">
                <img v-if="catalog.terminal_image" class="catalog-img" :src="catalog.terminal_image.public_path" width="300" height="400"/>
                <div class="text-center my-2" v-if="textHelpers && textHelpers.catalogText" v-html="getCatalogText(catalog.title)"></div>
                
                <div class="d-flex justify-content-center">
                    <button v-if="buttonText" 
                        class="btn px-4 btn-secondary d-flex justify-content-center"
                        @click.prevent="handleCatalogClick(catalog, index)"
                        :disabled="status.download[index]">

                        
                        <div class="pe-3" v-html="buttonText"></div> 
                        <div v-if="status.download[index]" class="text-center">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon" width="18" height="18" v-else>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FieldLayoutManager from './FieldLayoutManager.vue';
import Header from './Header&Footer/Header.vue';
import Footer from './Header&Footer/Footer.vue';
export default {
    inject: ['$validator'],
    props:{
        data:  Object,
        catalogs: Array,
        textHelpers: Object,
        locale: String,
        readonly: {
            type: Boolean,
            default: true
        }
    },
    components: {
        FieldLayoutManager, Footer, Header
    },
    mounted() {
        if (this.data.hideAfterSubmission && (this.$contact || (this.catalogs && this.catalogs.length > 0))) {
            this.isDownloadPage = this.catalogs && this.catalogs.length > 0;
            this.finished(true);
            return;
        }

        this.$nextTick(() => {
            // validators will be paused until the user hits 'OK' the first time
            this.$validator.pause();

            this.formFields.forEach(field => {
                const value = this.$contact && this.$contact[field.slug] ? this.$contact[field.slug] : null;
                if (value) this.disabledFields[field.slug] = true;
                if (this.$contact) this.$set(this.formFilled, field.slug, value)
            });

            if (this.$contact) {
                const index = this.formFields.findIndex(x => x.slug === 'phone');
                if (index != -1) {
                    this.formFields[index].help = "col-12 col-sm-12 col-md-12"
                }
            }

            // Load Cloudflare Turnstile script
            this.loadTurnstileScript();
        });
    },
    beforeDestroy() {
        // Clean up Turnstile widget
        if (this.turnstileWidgetId !== null && window.turnstile) {
            window.turnstile.remove(this.turnstileWidgetId);
        }
    },
    data() {
        return {
            formFilled: {},
            showCatalogs: false,
            status: {
                download: {}
            },
            disabledFields: {},
            emailsSent: [],
            turnstileToken: null,
            turnstileWidgetId: null,
            turnstileContainerId: `turnstile-container-${Math.random().toString(36).substr(2, 9)}`,
            isDownloadPage: false,
        };
    },
    computed: {
        formFields() {
            return this.data && this.data.config_json ? this.data.config_json.fields : []
        },
        buttonText() {
            return this.data?.config_json?.button_text ?? '';
        }
    },
    methods: {
        gtag_report_conversion(catalogSlug, url) {
            if (this.$locale !== 'es' || catalogSlug !== 'terminal-2') {
                return false;
            }
            
            const callback = () => {
                if (typeof(url) != 'undefined') {
                    window.location = url;
                }
            };
            
            gtag('event', 'conversion', {
                'send_to': 'AW-413478050/krAqCLP8w4UcEKLZlMUB',
                'event_callback': callback
            });
            return false;
        },
        loadTurnstileScript() {
            // Check if script already exists
            if (document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]')) {
                this.renderTurnstile();
                return;
            }

            // Create and load the Turnstile script
            const script = document.createElement('script');
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
            script.async = true;
            script.defer = true;
            script.onload = () => {
                this.renderTurnstile();
            };
            document.head.appendChild(script);
        },
        renderTurnstile() {
            // Wait for turnstile to be available
            if (!window.turnstile) {
                setTimeout(() => this.renderTurnstile(), 100);
                return;
            }

            // Fetch site key from API
            this.$axios.get('/api/v1/turnstile/config')
                .then(response => {
                    const siteKey = response.data.site_key;
                    
                    if (!siteKey) {
                        console.error('Turnstile site key not configured');
                        return;
                    }

                    // Render the Turnstile widget
                    this.turnstileWidgetId = window.turnstile.render(`#${this.turnstileContainerId}`, {
                        sitekey: siteKey,
                        theme: 'light',
                        language: this.locale,
                        callback: (token) => {
                            this.turnstileToken = token;
                        },
                        'error-callback': () => {
                            this.turnstileToken = null;
                        },
                        'expired-callback': () => {
                            this.turnstileToken = null;
                        }
                    });
                })
                .catch(error => {
                    console.error('Failed to load Turnstile config:', error);
                });
        },
        getCatalogText(text) {
            return Boolean(this.textHelpers?.catalogText) ? this.textHelpers.catalogText.replaceAll("{{catalog}}", text) : '';
        },
        finished(value) {
            if(this.data.hideAfterSubmission) {
                this.showCatalogs = value;
                const img = document.getElementById('form-download-image');
                if (img) img.style.display = "none";

                const container = document.getElementById('absolute-form');
                if (container) container.style.justifyContent = "center";
            } else {
                this.$emit('finished', this.formFilled);
                this.resetData();
            }
        },
        resetData() {
            this.$nextTick(() => {
                // validators will be paused until the user hits 'OK' the first time
                this.$validator.pause();
                Object.keys(this.formFilled).forEach(key => {
                    if (key === 'phone') {
                        this.disabledFields.phone = true;
                        this.$set(this.formFilled, key, null);
                    } else if (!this.disabledFields[key]) {
                        this.$set(this.formFilled, key, null);
                    }
                });
                
                // Reset Turnstile widget to get a new token
                if (this.turnstileWidgetId !== null && window.turnstile) {
                    window.turnstile.reset(this.turnstileWidgetId);
                }
            });
        },
        sendEmail(emails, index, title, catalogSlug) {
            if (this.emailsSent.includes(index)) {
                const reclamed = this.$locale == 'es' ? 'Se ha enviado un correo para descargar el catálogo.' : 'An email has been sent to download the catalog.';
                this.$swal('', reclamed, 'warning');
                return;
            }

            const email = emails.find(x => (x.language).toLowerCase() === this.locale.toLowerCase());
            const contactEmail = (this.formFilled ? this.formFilled.email : null) || (this.$contact ? this.$contact.email : null);

            if (email && contactEmail) {
                this.$set(this.status.download, index, true);

                this.$axios.post(`/api/v1/catalog/${email.template}/email`, {
                    data: {
                        email: contactEmail,
                        locale: this.locale,
                        catalog_slug: catalogSlug
                    }
                }).then(() => {
                    this.emailsSent.push(index);

                    if (this.data.config_json.confirm_notification) {
                        const notif = this.data.config_json.confirm_notification;
                        const notifTitle = (notif.title || '').replace('{{terminal}}', title);
                        const notifDescription= (notif.description || '').replace('{{terminal}}', title);
                        this.$swal(notifTitle, notifDescription, 'success');
                    }
                }).catch(() => {
                    this.$swal('Oops..','Something was wrong','error');
                }).finally(() => {
                    this.$set(this.status.download, index, false);
                })
            }
        },
        openCatalog(catalogSlug) {
            window.open(`/${this.locale == 'es' ? 'es/catalogo/descargar' : 'en/catalog/download'}/${catalogSlug}`, '_blank');
        },
        handleCatalogClick(catalog, index) {
            if (this.isDownloadPage) {
                this.openCatalog(catalog.slug);
            } else {
                this.sendEmail(catalog.message_template, index, catalog.title, catalog.slug);
            }
            this.gtag_report_conversion(catalog.slug);
        }
    }
}
</script>
<style scoped>
.vue_contact_form{
    background-color: transparent;
    display: flex;
    flex-wrap: wrap;
}
.catalog-img {
    width: calc(9vw + 9vh);
    height: calc(12vw + 12vh);
    object-fit: contain;
}
.catalog-title{
    font-size: 20px;
    font-weight: 700;
    margin: 20px 0 40px 0;
}
</style>